"use client";
import { jsx } from "react/jsx-runtime";
import { isBD } from "../../../../../../utils/businessType.lib.js";
import { Text } from "@nxt-costco-com/forge-components";
import "../../../../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../../../../Chrome/BrowseContext/hook.js";
import { useProductTileData } from "../../../../../../hooks/useProductTileData/index.js";
function TaxableItem() {
  var _a, _b, _c, _d;
  const { normalizedData, translationsConfig } = useProductTileData();
  const context = useBrowseContext();
  if (!((_a = translationsConfig == null ? void 0 : translationsConfig.translations) == null ? void 0 : _a.taxableitem) || !(normalizedData == null ? void 0 : normalizedData.taxableFoodItem)) {
    return null;
  }
  const location = isBD() ? (_c = (_b = context.bdDeliveryLocation) == null ? void 0 : _b.bdLocation) == null ? void 0 : _c.slice(-2) : (_d = context.deliveryLocation) == null ? void 0 : _d.state;
  if (!location || !normalizedData.taxableFoodItem.includes(location)) {
    return null;
  }
  return /* @__PURE__ */ jsx(Text, { color: "light", children: translationsConfig.translations.taxableitem });
}
export {
  TaxableItem
};
